const alertInformation = {
  styled: {
    padding: '10px 0px'
  },
  message:
    'Esta información es referencial y pueden variar al momento de matricularte según las vacantes.'
};

const courseTypeLabel = 'Modalidad de curso';

export { alertInformation, courseTypeLabel };
